import { Injectable } from "@angular/core";
import * as wjcCore from "@grapecity/wijmo";
import { environment } from "src/environments/environment";
import { CommonService } from "./common.service";
import { DatadogRumService } from "./datadog-rum.service";

@Injectable({
    providedIn: "root"
})
export class LicenseKeysBootstrapService {
    constructor(
        private commonService: CommonService,
        private datadogRumService: DatadogRumService
    ) {}

    async apply(resp: any): Promise<void> {
        if (!Array.isArray(resp)) return;

        const appVersion = this.commonService.extractAppVersionFromLicenseKeysResponse(resp);
        this.commonService.setCachedAppVersion(appVersion);

        const wijmoDistKey = resp.find((obj: any) => obj?.KeyName === "wijmoDistrKey");
        const fontawesome = resp.find((obj: any) => obj?.KeyName === "FONTAWESOME_NPM_AUTH_TOKEN");
        const dwtLicenseKey = resp.find((obj: any) => obj?.KeyName === "DWTLicenseKey");

        try {
            const licenseDecryptValue = this.commonService.DecryptData(localStorage.getItem("SfaxEncryptionVector"));
            const distKeyVal = this.commonService.DecryptData(
                wijmoDistKey?.KeyValue,
                false,
                licenseDecryptValue
            );
            if (distKeyVal) {
                wjcCore.setLicenseKey(distKeyVal);
            }
        } catch (e: any) {
            console.error("Error applying Wijmo license key:", e?.message || e);
        }

        try {
            if (dwtLicenseKey?.KeyValue) {
                localStorage.setItem("DWTLicensekey", dwtLicenseKey.KeyValue);
            }
        } catch {
            // ignore
        }

        try {
            environment.FONTAWESOME_NPM_AUTH_TOKEN = fontawesome;
        } catch {
            // ignore
        }

        const dataDogConfig = resp.find((obj: any) => obj?.KeyName === "DataDog");
        if (!dataDogConfig?.KeyValue) return;

        try {
            const sfaxVector = this.commonService.DecryptData(localStorage.getItem("SfaxEncryptionVector"));
            const configValue = this.commonService.DecryptData(dataDogConfig.KeyValue, false, sfaxVector);
            const parsedConfig = JSON.parse(configValue);
            if (appVersion) {
                parsedConfig.version = appVersion;
            }
            await this.datadogRumService.init(parsedConfig);
            this.commonService.setDatadog();
        } catch (e: any) {
            console.error("Error initializing Datadog from license keys:", e?.message || e);
        }
    }
}
